import { useEffect } from 'react';

function useScalable(isScalable: boolean) {
  useEffect(() => {
    const viewport = document.querySelector('meta[name=viewport]');

    viewport!.removeAttribute('content');

    if (isScalable) {
      return viewport!.setAttribute('content', 'width=device-width, initial-scale=1');
    }

    return viewport!.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
    );
  }, [isScalable]);
}

export default useScalable;
